// Unchecked "Remember Me" stores the token in sessionStorage instead of localStorage,
// so it doesn't survive a browser restart — localStorage ignored the checkbox entirely
// before this (flank#5116, AUTH-10).
const setAuthHeader = (token, remember = true) => {
  localStorage.removeItem('token');
  sessionStorage.removeItem('token');
  if (token) {
    (remember ? localStorage : sessionStorage).setItem('token', token);
  }
};

// sessionStorage first: if this tab has a session-only token ("Remember Me"
// unchecked) and a different tab has a persistent one for another account,
// checking localStorage first would silently switch this tab to that other
// account on reload (review, CodeRabbit, flank#5117).
export const getStoredAuthToken = () => sessionStorage.getItem('token') || localStorage.getItem('token');

export default setAuthHeader;
